import React from 'react';

import { Box, Paper, Skeleton } from '@mui/material';

const DelegationsSkeleton = (): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="start"
      height="100%"
    >
      <Box mb={4}>
        <Skeleton variant="text" animation="wave" height={30} />
        <Skeleton variant="text" animation="wave" height={20} />
      </Box>

      <Paper>
        <Box p={2}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="strech"
          >
            <Box flex={1} pr={2}>
              <Skeleton variant="text" animation="wave" height={20} />
              <Skeleton variant="rectangular" height={300} />
              <Skeleton variant="text" animation="wave" height={20} />
              <Skeleton variant="rectangular" height={300} />
            </Box>
            <Box flex={1} pl={2}>
              <Skeleton variant="text" animation="wave" height={20} />
              <Skeleton variant="rectangular" height={600} />
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default DelegationsSkeleton;
